import { Directive } from "@angular/core";

@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: "rask-list-column-checkbox"
})
export class ListColumnCheckboxDirective {
}
